import { DISH_PAGES } from "./dishes";
import { COMPARE_PAGES } from "./comparisons";
import { USE_PAGES } from "./uses";
import { LEARN_PAGES } from "./learn";

export const PSEO_PAGES = [...DISH_PAGES, ...COMPARE_PAGES, ...USE_PAGES, ...LEARN_PAGES];
export const PSEO_BY_SLUG = Object.fromEntries(PSEO_PAGES.map((p) => [p.slug, p]));
export const PSEO_GROUPS = [
  { key: "dish", title: "Cooking by dish", pages: DISH_PAGES },
  { key: "compare", title: "Compare oils", pages: COMPARE_PAGES },
  { key: "use", title: "Everyday uses", pages: USE_PAGES },
  { key: "learn", title: "Coconut oil science", pages: LEARN_PAGES },
];
